import { PresentationType, MonetizationType } from '@/@types/graphql-types';
import { TitleObjectType } from '@/interfaces/titles';

import { getVm } from '@/helpers/vm-helper';
const vm = getVm();

interface SponsoredRecommendationData {
	id: string;
	name: string;
	countries: Array<string>;
	start_date: number;
	end_date: number;
	provider_id: number;
	genres: string[];
	type: SponsoredRecommendationType;
	promotion: SponsoredRecommendationPromotion;
	content: {
		id: string;
		objectType: TitleObjectType;
		objectId: number;
		watchNowOffer: {
			[key: string]: {
				/** @Warning Do not use a link that starts with click.justwatch.com or it will get double affiliated! */
				standardWebURL: string;
				currency: string;
				package: {
					clearName: string;
					packageId: number;
				};
				monetizationType: MonetizationType;
				presentationType: PresentationType;
			};
		};
	};
	watchnowLabel?: string;
	/** Enter the backdrop image name WITHOUT its format type (e.g: without .png) */
	backdropImageName: string;
	impressionTag: string;
}

enum SponsoredRecommendationType {
	Regular = 'REGULAR',
	Cinematic = 'CINEMATIC',
}

enum SponsoredRecommendationPromotion {
	/** Sponsored Recommendation in SimilarTitles at bottom of TitleDetail */
	None = 'NONE',

	/** Sponsored Recommendation in SimilarTitles below BuyBox */
	Low = 'LOW',

	/** Sponsored Recommendation in SimilarTitles above Buybox */
	High = 'HIGH',
}

// List of current Sponsored Recommendations:
const sponsoredRecommendations: Array<SponsoredRecommendationData> = [
	{
		id: 'a6068395-5ffb-49f6-9046-6a5c62e1b343',
		name: 'Demon Slayer Kimetsu No Yaiba',
		countries: ['US', 'BR', 'MX'],
		start_date: new Date('2023-04-21').setUTCHours(0, 0, 0, 0),
		end_date: new Date('2023-04-28').setUTCHours(23, 59, 59, 999),
		provider_id: 283, // Crunchyroll
		genres: ['act', 'ani', 'fnt'], // Action & Adventure, Animation, Fantasy
		type: SponsoredRecommendationType.Regular,
		promotion: SponsoredRecommendationPromotion.Low,
		content: {
			id: 'ts87466', // Demon Slayer Kimetsu No Yaiba
			objectType: TitleObjectType.SHOW,
			objectId: 87466, // Demon Slayer Kimetsu No Yaiba
			watchNowOffer: {
				US: {
					standardWebURL:
						'https://click.justwatch.com/a?r=https%3A%2F%2Fcrunchyroll.pxf.io%2Fxk92Nv%3Fu%3Dhttps%253A%252F%252Fwww.crunchyroll.com%252Fwatch%252FGJWU2E1J7%252Fsomeones-dream%26subId3%3Djustappsvod&cx=eyJzY2hlbWEiOiJpZ2x1OmNvbS5zbm93cGxvd2FuYWx5dGljcy5zbm93cGxvdy9jb250ZXh0cy9qc29uc2NoZW1hLzEtMC0wIiwiZGF0YSI6W3sic2NoZW1hIjoiaWdsdTpjb20uanVzdHdhdGNoL3RpdGxlX2NvbnRleHQvanNvbnNjaGVtYS8xLTEtMCIsImRhdGEiOnsidGl0bGVJZCI6ODc0NjYsIm9iamVjdFR5cGUiOiJzaG93Iiwic2Vhc29uTnVtYmVyIjozLCJqd0VudGl0eUlkIjoidHM4NzQ2NiJ9fSx7InNjaGVtYSI6ImlnbHU6Y29tLmp1c3R3YXRjaC9jbGlja291dF9jb250ZXh0L2pzb25zY2hlbWEvMS0yLTAiLCJkYXRhIjp7InByb3ZpZGVyIjoiQ3J1bmNoeXJvbGwiLCJwcm92aWRlcklkIjoyODMsIm1vbmV0aXphdGlvblR5cGUiOiJmbGF0cmF0ZSIsInByZXNlbnRhdGlvblR5cGUiOiJoZCIsImN1cnJlbmN5IjoiVVNEIiwicGFydG5lcklkIjoxfX1dfQ&uct_country=US&uct_buybox=normal&uct_sport=&sid=&uct_ct=',
					currency: 'USD',
					package: {
						clearName: 'Crunchyroll',
						packageId: 283, // Crunchyroll
					},
					monetizationType: MonetizationType.Flatrate,
					presentationType: PresentationType.Hd,
				},
				BR: {
					standardWebURL:
						'https://click.justwatch.com/a?r=https%3A%2F%2Fcrunchyroll.pxf.io%2Fxk92Nv%3Fu%3Dhttps%253A%252F%252Fwww.crunchyroll.com%252Fwatch%252FGJWU2E1J7%252Fsomeones-dream%26subId3%3Djustappsvod&cx=eyJzY2hlbWEiOiJpZ2x1OmNvbS5zbm93cGxvd2FuYWx5dGljcy5zbm93cGxvdy9jb250ZXh0cy9qc29uc2NoZW1hLzEtMC0wIiwiZGF0YSI6W3sic2NoZW1hIjoiaWdsdTpjb20uanVzdHdhdGNoL3RpdGxlX2NvbnRleHQvanNvbnNjaGVtYS8xLTEtMCIsImRhdGEiOnsidGl0bGVJZCI6ODc0NjYsIm9iamVjdFR5cGUiOiJzaG93Iiwic2Vhc29uTnVtYmVyIjozLCJqd0VudGl0eUlkIjoidHM4NzQ2NiJ9fSx7InNjaGVtYSI6ImlnbHU6Y29tLmp1c3R3YXRjaC9jbGlja291dF9jb250ZXh0L2pzb25zY2hlbWEvMS0yLTAiLCJkYXRhIjp7InByb3ZpZGVyIjoiQ3J1bmNoeXJvbGwiLCJwcm92aWRlcklkIjoyODMsIm1vbmV0aXphdGlvblR5cGUiOiJmbGF0cmF0ZSIsInByZXNlbnRhdGlvblR5cGUiOiJoZCIsImN1cnJlbmN5IjoiQlJMIiwicGFydG5lcklkIjoxfX1dfQ&uct_country=BR&uct_buybox=normal&uct_sport=&sid=&uct_ct=',
					currency: 'BRL',
					package: {
						clearName: 'Crunchyroll',
						packageId: 283, // Crunchyroll
					},
					monetizationType: MonetizationType.Flatrate,
					presentationType: PresentationType.Hd,
				},
				MX: {
					standardWebURL:
						'https://click.justwatch.com/a?r=https%3A%2F%2Fcrunchyroll.pxf.io%2Fxk92Nv%3Fu%3Dhttps%253A%252F%252Fwww.crunchyroll.com%252Fwatch%252FGJWU2E1J7%252Fsomeones-dream%26subId3%3Djustappsvod&cx=eyJzY2hlbWEiOiJpZ2x1OmNvbS5zbm93cGxvd2FuYWx5dGljcy5zbm93cGxvdy9jb250ZXh0cy9qc29uc2NoZW1hLzEtMC0wIiwiZGF0YSI6W3sic2NoZW1hIjoiaWdsdTpjb20uanVzdHdhdGNoL3RpdGxlX2NvbnRleHQvanNvbnNjaGVtYS8xLTEtMCIsImRhdGEiOnsidGl0bGVJZCI6ODc0NjYsIm9iamVjdFR5cGUiOiJzaG93Iiwic2Vhc29uTnVtYmVyIjozLCJqd0VudGl0eUlkIjoidHM4NzQ2NiJ9fSx7InNjaGVtYSI6ImlnbHU6Y29tLmp1c3R3YXRjaC9jbGlja291dF9jb250ZXh0L2pzb25zY2hlbWEvMS0yLTAiLCJkYXRhIjp7InByb3ZpZGVyIjoiQ3J1bmNoeXJvbGwiLCJwcm92aWRlcklkIjoyODMsIm1vbmV0aXphdGlvblR5cGUiOiJmbGF0cmF0ZSIsInByZXNlbnRhdGlvblR5cGUiOiJoZCIsImN1cnJlbmN5IjoiTVhOIiwicGFydG5lcklkIjoxfX1dfQ&uct_country=MX&uct_buybox=normal&uct_sport=&sid=&uct_ct=',
					currency: 'MXN',
					package: {
						clearName: 'Crunchyroll',
						packageId: 283, // Crunchyroll
					},
					monetizationType: MonetizationType.Flatrate,
					presentationType: PresentationType.Hd,
				},
			},
		},
		watchnowLabel: vm.$tc('WEBAPP_TRY_NOW_FOR_FREE'),
		backdropImageName: 'demon-slayer-s3', // Enter the backdrop image name WITHOUT its format type (e.g: without .png)
		impressionTag: '',
	},
];

const customSponsoredRecommendations: Array<any> = [
	{
		id: 'a41049ba-0775-4a43-8923-9af4f97df32d',
		name: 'JustWatch Favorites',
		countries: [
			'US',
			'UK',
			'AU',
			'NZ',
			'IE',
			'IN',
			'ZA',
			'NG',
			'CA',
			'KE',
			'AE',
			'SA',
			'BA',
			'QA',
			'EG',
			'PL',
			'NL',
			'BE',
			'IT',
			'FR',
			'CH',
			'DZ',
			'ES',
			'MX',
			'AR',
			'DE',
			'AT',
			'PT',
			'BR',
			'TR',
		],
		start_date: new Date('2023-04-07').setUTCHours(0, 0, 0, 0),
		end_date: new Date('2023-04-10').setUTCHours(23, 59, 59, 999),
		title: 'JustWatch Favorites',
		text: vm.$tc('WEBAPP_LIST_JWFAVORITES_CONTEXT'),
		fullPath: 'https://justwatch.com/shared?id=tl-tu-4ab579f5-b3e7-4fb5-8c9d-1032cd7befd3',
		backdropImageName: 'jw_favorites-2',
	},
];

const getSponsoredRecommendations = (country: string) => {
	const now = new Date().getTime();
	return sponsoredRecommendations.filter((sr: SponsoredRecommendationData) => {
		return sr.countries.includes(country) && sr.start_date <= now && now <= sr.end_date;
	});
};

const getCustomSponsoredRecommendations = (country: string) => {
	const now = new Date().getTime();
	return customSponsoredRecommendations.filter((sr: any) => {
		return sr.countries.includes(country) && sr.start_date <= now && now <= sr.end_date;
	});
};

const sponsoredRecommendationProviders = () => {
	return sponsoredRecommendations.map((sr: SponsoredRecommendationData) => {
		return sr.provider_id;
	});
};

const isSponsoredRecommendationTitle = (id: string | undefined, country: string) => {
	const now = new Date().getTime();
	return !!sponsoredRecommendations.find((sr: SponsoredRecommendationData) => {
		return sr.content.id === id && sr.countries.includes(country) && sr.start_date <= now && now <= sr.end_date;
	});
};

const showSponsoredRecommendations = (country: string) => {
	const now = new Date().getTime();
	return (
		!!sponsoredRecommendations.find((sr: SponsoredRecommendationData) => {
			return sr.countries.includes(country) && sr.start_date <= now && now <= sr.end_date;
		}) ||
		!!customSponsoredRecommendations.find((sr: any) => {
			return sr.countries.includes(country) && sr.start_date <= now && now <= sr.end_date;
		})
	);
};

export {
	SponsoredRecommendationData,
	sponsoredRecommendations,
	customSponsoredRecommendations,
	getSponsoredRecommendations,
	getCustomSponsoredRecommendations,
	sponsoredRecommendationProviders,
	isSponsoredRecommendationTitle,
	showSponsoredRecommendations,
	SponsoredRecommendationPromotion,
	SponsoredRecommendationType,
};
